module.exports = __webpack_public_path__ + "img/silver5.be497415.gif";